<script lang="ts" setup>
import { LoaderOverlay } from '@UI/Loaders/LoaderOverlay'

defineOptions({
  name: 'SkeletonSectionDemo',
})

</script>

<template>
  <div class="demo skeleton">
    <LoaderOverlay />
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Sections/Demo/SectionDemo.scss" />
